module.exports = __webpack_public_path__ + "static/img/pic14.d8fc2145.png";